import "globalthis-polyfill"
import queueMicrotask from "queue-microtask"
import smoothscroll from "smoothscroll-polyfill"

if (typeof window.queueMicrotask !== "function") {
  window.queueMicrotask = queueMicrotask
}

smoothscroll.polyfill()
